import { Strings } from "src/resources";

export const queryKey = {
  getDashboard: "getDashboard",
  getYear: "getYear",
  getItinerary: "getItinerary",
  getItineraryById: "getItineraryById",
  getAgency: "getAgency",
  getAgent: "getAgent",
  getBooker: "getBooker",
  getHotels: "getHotels",
  getHotelById: "getHotelById",
  getMessage: "getMessage",
  getEiMessage: "getEiMessage",
  getViewEiMessage: "getViewEiMessage",
  getRegion: "getRegion",
  getEvent: "getEvent",
  getAvesById: "avesById",
  getTermsCondition: "getTermsCondition",
  getServicesById: "getServicesById",
  getServiceType: "getServiceType",
  getSupplier: "getSupplier",
  getService: "getService",
  getHotelMessage: "getHotelMessage",
  getNotification: "getNotification"
};

export const userRoles = {
  superAdmin: "Super Admin",
  subAdmin: "Sub Admin",
  booker: "Booker"
};

export const localStorageKey = {
  userRole: "userRole",
  userInfo: "userInfo",
  authToken: "authToken",

};

export enum itineraryViewTabEnum {
  tab = "tab",
  list = "list",
}

export const DEFAULT_DATE_FORMAT = "DD-MM-YYYY";

export const cartasiData = {
  internalCostPercentage: 2.25
};

export const ItineraryStatusCodes = {
  draft: "D",
  pendingAgentApproval: "PAA",
  partialPaid: "PP",
  fullyPaid: "FP",
  confirmed: "CNF",
  completeWithAves: "AVES"
};

export const selectItineraryStatusOptions = [
  {
    value: ItineraryStatusCodes?.draft,
    label: "Draft",
    bgColor: "rgba(223, 94, 78, 0.16)",
    color: "#D94230"
  },
  {
    value: ItineraryStatusCodes?.pendingAgentApproval,
    label: "Pending Agent Approval",
    bgColor: "rgba(236, 155, 24, 0.14)",
    color: "#CF8711"
  },
  {
    value: ItineraryStatusCodes?.confirmed,
    label: "Confirmed",
    bgColor: "rgba(31, 168, 37, 0.14)",
    color: "#198a1e"
  },
  {
    value: ItineraryStatusCodes?.partialPaid,
    label: "Partial Paid",
    bgColor: "rgba(236, 155, 24, 0.14)",
    color: "#CF8711"
  },
  {
    value: ItineraryStatusCodes?.fullyPaid,
    label: "Fully Paid",
    bgColor: "rgba(31, 168, 37, 0.14)",
    color: "#198a1e"
  },

  {
    value: ItineraryStatusCodes?.completeWithAves,
    label: "Completed with AVES",
    bgColor: "rgba(31, 168, 37, 0.14)",
    color: "#198a1e"
  }
];
export const dashboardFilterCode = {
  currentMonth: "CUM",
  lastMonth: "LAM",
  last6Months: "L6M",
  lastYear: "LAY",
  custom: "CUSTOM"
};

export const selectDashboardFilterOptions = [
  { value: dashboardFilterCode.currentMonth, label: Strings.current_month },
  { value: dashboardFilterCode.lastMonth, label: Strings.last_month },
  { value: dashboardFilterCode.last6Months, label: Strings.last_6_months },
  { value: dashboardFilterCode.lastYear, label: Strings.last_year },
  { value: dashboardFilterCode.custom, label: Strings.custom }
];

export const monthOptions = [
  { value: 1, label: Strings.jan },
  { value: 2, label: Strings.feb },
  { value: 3, label: Strings.mar },
  { value: 4, label: Strings.apr },
  { value: 5, label: Strings.may },
  { value: 6, label: Strings.jun },
  { value: 7, label: Strings.jul },
  { value: 8, label: Strings.aug },
  { value: 9, label: Strings.sep },
  { value: 10, label: Strings.oct },
  { value: 11, label: Strings.nov },
  { value: 12, label: Strings.dec }
];

export const timeUnits = {
  day: "day",
  month: "month",
  year: "year"
};

export const LIST_ITEM_PER_PAGE_COUNT = 10;

export const TOAST_IDS = {
  logout: "toast-logout"
};

export const SERVICE_TYPE_FIELD = {
  serviceType: "serviceType",
  transportation: "Transportation",
  internalCost: "internalCost"
};

export const PUSH_ITINERARY_TYPE = {
  axus: "AXUS",
  travefy: "Travefy"
};

export const BOOK_HOTEL_FIELD = {
  address: "address",
  phone: "phone",
  website: "website",
  propertyDescription: "propertyDescription",
  checkInDate: "checkInDate",
  checkOutDate: "checkOutDate",
  checkInTime: "checkInTime",
  checkOutTime: "checkOutTime",
  rooms: "rooms",
  payment: "payment",
  price: "price",
  cancellationPolicy: "cancellationPolicy",
  notes: "notes",
  amenities: "amenities",
  status: "status",
  salability: "salability",
  lastReviewBy: "lastReviewBy",
  lastReviewDate: "lastReviewDate",
  collaboratorNote: "collaboratorNote",
  internalNote: "internalNote"
};

export const HOTEL_BEDDING_TYPE = [
  { value: "bunkBeds", label: Strings.bunk_beds },
  { value: "king", label: Strings.king },
  { value: "queen", label: Strings.queen },
  { value: "twin", label: Strings.twin },
  { value: "double", label: Strings.double },
  { value: "europeanQueen", label: Strings.european_queen },
  { value: "kingTwin", label: `${Strings.king}/${Strings.twin}` },
  { value: "single", label: Strings.single },
  { value: "threeKings", label: Strings.three_kings },
  { value: "twoKings", label: Strings.two_kings },
  { value: "twoQueens", label: Strings.two_queens },
  { value: "twoDoubles", label: Strings.two_doubles },
  { value: "twoTwins", label: Strings.two_twins },
  { value: "twoSingles", label: Strings.two_singles },
  { value: "doubleDouble", label: `${Strings.double}/${Strings.double}` },
  { value: "fourPost", label: Strings.four_post },
  { value: "matrimonial", label: Strings.matrimonial },
  { value: "frenchBed", label: Strings.french_beds }
];

export const INITIALS_COLOR = {
  A: "bg-cream-10",
  B: "bg-teal-5",
  C: "bg-teal-10",
  D: "bg-teal-15",
  E: "bg-green-15",
  F: "bg-pink-10",
  G: "bg-purple-10",
  H: "bg-blue-5",
  I: "bg-pink-15",
  J: "bg-yellow-15",
  K: "bg-blue-25",
  L: "bg-peach-10",
  M: "bg-peach-20",
  N: "bg-cream-10",
  O: "bg-teal-5",
  P: "bg-teal-10",
  Q: "bg-teal-15",
  R: "bg-green-15",
  S: "bg-pink-10",
  T: "bg-purple-10",
  U: "bg-blue-5",
  V: "bg-pink-15",
  W: "bg-yellow-15",
  X: "bg-blue-25",
  Y: "bg-peach-10",
  Z: "bg-peach-20"
};

export const SERVICE_TYPE = {
  air: "Air",
  concierge: "Concierge",
  other_notes: "Other/Notes",
  tour_activity: "Tour/Activity",
  insurance: "Insurance",
  transportation: "Transportation",
  cruise: "Cruise"
};

export const TRANSPORTATION_TRANSIT_TYPE = {
  ferry: "ferry",
  rail: "rail",
  transfer: "transfer",
  other: "other",
  rentalCar: "rentalCar"
};
